/* KLOUT — Página de carrito (/cart). AJAX para cantidad, eliminar, upsell y promo.
   Re-render con la Section Rendering API. Sin librerías. */
(function () {
  'use strict';

  class KloutCart extends HTMLElement {
    connectedCallback() {
      this.sectionId = this.dataset.section;
      this.busy = false;

      this.addEventListener('click', (e) => {
        var dec = e.target.closest('[data-kc-dec]');
        if (dec) { this.step(dec, -1); return; }
        var inc = e.target.closest('[data-kc-inc]');
        if (inc) { this.step(inc, 1); return; }
        var rm = e.target.closest('[data-kc-remove]');
        if (rm) { this.changeLine(this.lineOf(rm), 0); return; }
        var add = e.target.closest('[data-kc-add]');
        if (add) { this.addVariant(add); return; }
        var promo = e.target.closest('[data-kc-promo-apply]');
        if (promo) { this.applyPromo(); return; }
      });

      this.addEventListener('change', (e) => {
        var qn = e.target.closest('[data-kc-qty]');
        if (qn) {
          var q = parseInt(qn.value, 10);
          if (isNaN(q) || q < 0) q = 0;
          this.changeLine(this.lineOf(qn), q);
        }
      });

      this.addEventListener('keydown', (e) => {
        if (e.key === 'Enter' && e.target.closest('[data-kc-promo]')) { e.preventDefault(); this.applyPromo(); }
      });
    }

    lineOf(el) {
      var row = el.closest('[data-line]');
      return row ? parseInt(row.getAttribute('data-line'), 10) : null;
    }

    step(btn, dir) {
      var wrap = btn.closest('.kcart-qty');
      if (!wrap) return;
      var input = wrap.querySelector('[data-kc-qty]');
      var cur = parseInt(input ? input.value : '1', 10) || 1;
      var next = cur + dir;
      if (next < 0) next = 0;
      this.changeLine(this.lineOf(btn), next);
    }

    base() {
      return (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    }

    lock(on) {
      this.busy = on;
      this.setAttribute('aria-busy', on ? 'true' : 'false');
      this.style.opacity = on ? '0.55' : '';
      this.style.pointerEvents = on ? 'none' : '';
    }

    changeLine(line, quantity) {
      if (this.busy || line == null) return;
      this.lock(true);
      fetch(this.base() + 'cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ line: line, quantity: quantity, sections: this.sectionId, sections_url: window.location.pathname })
      })
        .then((r) => r.json())
        .then((data) => this.afterUpdate(data))
        .catch(() => this.lock(false));
    }

    addVariant(btn) {
      if (this.busy) return;
      var id = btn.getAttribute('data-vid');
      if (!id) return;
      btn.setAttribute('aria-busy', 'true');
      this.lock(true);
      fetch(this.base() + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: id, quantity: 1, sections: this.sectionId, sections_url: window.location.pathname })
      })
        .then((r) => r.json())
        .then((data) => this.afterUpdate(data))
        .catch(() => this.lock(false));
    }

    afterUpdate(data) {
      var count = data && typeof data.item_count === 'number' ? data.item_count : null;
      var html = data && data.sections && data.sections[this.sectionId];
      if (html) {
        // Camino ligero: la Section Rendering API devolvió el HTML de la sección.
        this.swap(html);
        this.updateBadges(count);
        this.lock(false);
      } else {
        // Fallback robusto (p.ej. el servidor dev no soporta section rendering):
        // recargar la página /cart por fetch y reemplazar el contenido.
        this.fullRefresh(count);
      }
    }

    fullRefresh(count) {
      fetch(window.location.pathname, { headers: { 'Accept': 'text/html' } })
        .then((r) => r.text())
        .then((html) => {
          this.swap(html);
          this.updateBadges(count);
          this.lock(false);
        })
        .catch(() => { window.location.reload(); });
    }

    swap(html) {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var fresh = doc.querySelector('klout-cart');
      this.innerHTML = fresh ? fresh.innerHTML : html;
      // Re-inicializa los botones de pago dinámico de Shopify (Shop Pay, etc.)
      if (window.Shopify && window.Shopify.PaymentButton && typeof window.Shopify.PaymentButton.init === 'function') {
        try { window.Shopify.PaymentButton.init(); } catch (e) {}
      }
    }

    updateBadges(count) {
      if (count == null) return;
      // Tab bar
      var tb = document.getElementById('ktab-badge');
      if (tb) { if (count > 0) { tb.textContent = count; tb.hidden = false; } else { tb.hidden = true; } }
      // Burbuja del header de Dawn
      document.querySelectorAll('.cart-count-bubble').forEach(function (b) {
        if (count > 0) {
          b.style.display = '';
          var n = b.querySelector('span[aria-hidden="true"]') || b.querySelector('span');
          if (n) n.textContent = count;
        } else {
          b.style.display = 'none';
        }
      });
      // Notifica a otros componentes (cart drawer) que el carrito cambió
      document.documentElement.dispatchEvent(new CustomEvent('klout:cart:updated', { detail: { count: count } }));
    }

    applyPromo() {
      var input = this.querySelector('[data-kc-promo]');
      if (!input) return;
      var code = (input.value || '').trim();
      if (!code) { input.focus(); return; }
      window.location.href = this.base() + 'discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent(window.location.pathname);
    }
  }

  if (!customElements.get('klout-cart')) customElements.define('klout-cart', KloutCart);
})();
